import React from "react";
import { startCase } from "lodash";
import { Box, Tab, Tabs } from "@mui/material";

import { ShiftSettings } from "./ShiftSettings/ShiftSettings";
import { LeaveTypeSettings } from "./LeaveTypeSettings/LeaveTypeSettings";
import { HolidaySettings } from "./HolidaySettings/HolidaySettings";
import { BiometricDeviceSettings } from "./BiometricDeviceSettings/BiometricDeviceSettings";
import { GeneralAttendanceSettings } from "./GeneralAttendanceSettings/GeneralAttendanceSettings";
import SettingsButton from "../../../../components/SettingsButton/SettingsButton";
import Panel from "../../../../components/Panel";

const TABS = {
  SHIFT_SETTINGS: "shiftSettings",
  LEAVE_TYPE_SETTINGS: "leaveTypeSettings",
  HOLIDAY_SETTINGS: "holidaySettings",
  BIOMETRIC_DEVICE_SETTINGS: "biometricDeviceSettings",
  GENERAL_ATTENANCE_SETTINGS: "generalAttendanceSettings"
};

interface Props {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  renderSettingButton?: boolean;
}

// eslint-disable-next-line import/prefer-default-export
export const AttendanceSettingsPanel = ({
  open,
  onOpenChange,
  renderSettingButton = true
}: Props): React.ReactNode => {
  const [selectedTab, setSelectedTab] = React.useState(TABS.SHIFT_SETTINGS);

  const [internalOpen, setInternalOpen] = React.useState(false);

  const isControlled = typeof open === "boolean";
  const actualOpen = isControlled ? open : internalOpen;

  const setOpen = (value: boolean): void => {
    if (isControlled) {
      onOpenChange?.(value);
    } else {
      setInternalOpen(value);
    }
  };

  return (
    <>
      {renderSettingButton && <SettingsButton onClick={() => setOpen(!actualOpen)} />}

      {actualOpen && (
        <Panel
          onClose={() => setOpen(false)}
          title="Attendance Settings"
          contentStyle={{ py: 0, height: "calc(100vh - 50px)" }}
          wrapperStyle={{
            width: "calc(100vw - 80px)",
            maxWidth: "calc(100vw - 80px)"
          }}
        >
          <Box sx={{ height: "100%", borderLeft: 1, borderRight: 1, borderColor: "divider" }}>
            <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              <Tabs
                value={selectedTab}
                onChange={(_, newValue) => setSelectedTab(newValue)}
                sx={{
                  height: "50px",
                  borderBottom: 1,
                  borderColor: "divider"
                }}
              >
                <Tab label={startCase(TABS.SHIFT_SETTINGS)} value={TABS.SHIFT_SETTINGS} />
                <Tab label={startCase(TABS.LEAVE_TYPE_SETTINGS)} value={TABS.LEAVE_TYPE_SETTINGS} />
                <Tab label={startCase(TABS.HOLIDAY_SETTINGS)} value={TABS.HOLIDAY_SETTINGS} />
                <Tab
                  label={startCase(TABS.BIOMETRIC_DEVICE_SETTINGS)}
                  value={TABS.BIOMETRIC_DEVICE_SETTINGS}
                />
                <Tab
                  label={startCase(TABS.GENERAL_ATTENANCE_SETTINGS)}
                  value={TABS.GENERAL_ATTENANCE_SETTINGS}
                />
              </Tabs>

              <Box sx={{ height: "calc(100vh - 100px)", overflowY: "auto" }}>
                {selectedTab === TABS.SHIFT_SETTINGS && <ShiftSettings />}
                {selectedTab === TABS.LEAVE_TYPE_SETTINGS && <LeaveTypeSettings />}
                {selectedTab === TABS.HOLIDAY_SETTINGS && <HolidaySettings />}
                {selectedTab === TABS.BIOMETRIC_DEVICE_SETTINGS && <BiometricDeviceSettings />}
                {selectedTab === TABS.GENERAL_ATTENANCE_SETTINGS && <GeneralAttendanceSettings />}
              </Box>
            </Box>
          </Box>
        </Panel>
      )}
    </>
  );
};
